<template>
    <div>
        <mensajeSistema></mensajeSistema>

        <v-form ref="formEvaluacionAlumno" lazy-validation>
            <v-card>
                <v-card-text>
                    <v-row>
                        <!-- <v-col cols="12">
                            {{ parametros }}
                            fecha_informat
                        </v-col> -->
                        <v-col cols="12" class="pt-0 px-0">

                            <h4 class="py-2"> <v-icon small>fa-check</v-icon> Lista de estudiantes de la sección: {{
                                datosSeccion.nombre_seccion }}</h4>

                            <v-data-table :headers="headers" :items="AlumnosSeccion" :sort-by="['ape2_alumno']" dense
                                :sort-desc="[true]" class="header_datatable" :disable-pagination="true"
                                :hide-default-footer="true">

                                <template v-slot:[`header.check`]>
                                    SELECCIONAR <br />
                                    <v-simple-checkbox :disabled="parametros.items.id ? true : false"
                                        v-model="allSelected" @click="SelectAll"></v-simple-checkbox>
                                </template>

                                <template v-slot:[`item.alumno_ap`]="{ item }">
                                    <span>{{ item.ape1_alumno + " " + item.ape2_alumno + " " + item.nombre_alumno
                                        }}</span>
                                </template>

                                <template v-slot:[`item.observacion`]="{ item }">
                                    <v-text-field v-model="item.observacion_docente" label="observación"
                                        class="pb-0 pt-1" type="text" dense single-line
                                        :disabled="item.alumno_check == false"></v-text-field>
                                </template>

                                <template v-slot:[`item.check`]="{ item }">
                                    <v-simple-checkbox v-model="item.alumno_check"
                                        :disabled="parametros.items.id ? true : false"
                                        @input="checkAlumno(item)"></v-simple-checkbox>
                                </template>

                            </v-data-table>
                        </v-col>
                    </v-row>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <TableButtonComp normalButton @click="SaveItem();"
                        :textButton="parametros.items.id ? 'Actualizar' : 'Completar'" iconBut="" />
                </v-card-actions>
            </v-card>
        </v-form>
    </div>
</template>


<script>
import axios, { API_URL } from '@/helpers/axios'
import { mapMutations, mapGetters, mapState, mapActions } from 'vuex'
import TableButtonComp from '../../../../../components/ComponentsEst/TableButtonComp.vue'

export default {
    name: "evaluacionAlumnos",
    components: {
        TableButtonComp,
    },
    props: {
        parametros: {
            type: Object
        },
        estadoComp: {
            type: Boolean
        },
        estadoValidacion: {
            type: Boolean
        },
        wizardChange: {
            type: Number
        }
    },
    data: () => ({
        paramComponente: { "id_modulo": 8, 'id_submodulo': 96 },
        datoLogin: sessionStorage,
        ruta_api: API_URL,
        test: false,
        tabIndex: 3,
        evento: null,
        textAlert: "",
        data: [],
        datosSeccion: {},
        search: '',
        AlumnosSeccion: [],
        allSelected: false,
        disabledEdit: false,
        headers: [
            { text: 'Nº. DOCUMENTO DE IDENTIDAD', value: 'numdoc_alumno', class: 'header_datatable' },
            { text: 'APELLIDOS Y NOMBRES', value: 'alumno_ap', class: 'header-datatable' },
            { text: 'OBSERVACIÓN', value: 'observacion', class: 'header-datatable', sortable: false },
            { text: 'SELECCIONAR', value: 'check', align: 'center', class: 'header-datatable', sortable: false },
        ],

        stepsValid: null
    }),
    mounted() {
        this.LoadMain()
    },
    computed: {
        ...mapGetters({
            componenteEvento: 'login/componenteEvento',
            formValidados: 'gestEvaluacion/formValidados',
        }),
        ...mapState({
            wizarData: state => state.gestEvaluacion.wizarData,
            listaPreguntasArray: state => state.gestEvaluacion.listaPreguntasArray,
            evaluacionInformacion: state => state.gestEvaluacion.evaluacionInformacion,
            evaluacionCompetencias: state => state.gestEvaluacion.evaluacionCompetencias,
            evaluacionAlumnos: state => state.gestEvaluacion.evaluacionAlumnos,
        }),
    },
    filters: {
        quitarTag: function (string) {
            return string.replace(/<\/?[^>]+>/ig, " ");
        },
    },
    watch: {
        estadoComp(flag) {
            if (flag) {
                this.LoadMain();
            } else {
                // this.limpiarForm();
            }
        },
        estadoValidacion(flag) {
            if (flag) {
                // console.log(flag);
            }
        },
        // wizardChange(step) {
        //     if (step == 4) {
        //         console.log('read 4 step');                
        //     }
        // }
    },
    methods: {
        ...mapMutations({
            setEnviarMens: "mensajeSis/setEnviarMens",
            setEvalAlumnos: "gestEvaluacion/setEvalAlumnos"
        }),
        ...mapActions({
            parametroComponente: "login/parametroComponente",
            validateForm: "gestEvaluacion/validateForm",
        }),
        /** 
         __________________________________________
        |          MÉTODO CARGA INICIAL          */
        async LoadMain() {
            this.LimpiarForm()
            this.GetAlumnoEval()
            this.evento = this.parametros.evento
            this.datosSeccion = this.parametros.items
            this.stepsValid = this.formValidados;
            if (this.parametros.evento == 'add') {
                this.textAlert = 'registrada';
                this.AddItem()
            }
            else if (this.parametros.evento == 'edit') {
                this.textAlert = 'actualizada';
                this.EditItem()
            }
        },
        /** 
         _________________________________________________________________
        |          MÉTODO MARCAR O SELECCIONAR ALUMNO - CHECKED         */
        // eslint-disable-next-line no-unused-vars
        checkAlumno(itemAlumnos) {
            let atLeastOne = this.AlumnosSeccion.some((item) => item.alumno_check);
            this.validateForm({ index: 3, value: atLeastOne });
        },
        /** 
         ____________________________________________________________________
        |          MÉTODO OBTENER TODOS LOS ALUMNOS DE LA SECCIÓN          */
        async GetAlumnoEval() {

            try {
                let filter = {
                    id_ano_lectivo: this.parametros.items.id_ano_lectivo,
                    id_colegio: this.parametros.items.id_colegio,
                    id_evaluacion: this.parametros.items.id,
                    id_seccion: this.parametros.items.id_seccion,
                    id_usuario: this.datoLogin.id
                }

                let response = await axios.post(`/evaluacion/alumnos/`, filter)
                this.AlumnosSeccion = response.data.SeccionAlumno;
                if (this.AlumnosSeccion.length == 0) {
                    this.setEnviarMens({ tipo: "W", mensaje: `No se encontrarón registros`, tiempo: null })
                }

            } catch (error) {
                console.log(error)
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })
            }

        },
        /** 
         ________________________________________________________________________________
        |          MÉTODO OBTENER TODOS LOS ALUMNOS DE LA SECCIÓN SELECCIONADOS         */
        async GetAlumnoEvalSelected() {

            try {

                let response = await axios.get(`/evaluacion/alumnos/getAlumnoEval/${this.parametros.items.id}`)
                response.data.forEach(itemB => {
                    const Alumnos = this.AlumnosSeccion.find(itemA => itemA.id == itemB.id);
                    if (Alumnos) {
                        Alumnos.alumno_check = true;
                    }
                });

            } catch (error) {
                console.log(error)
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })
            } finally {
                // this.disabledEdit = true;
            }
        },
        /** 
         ______________________________________________________________________
        |          MÉTODO SELECCIONAR TODOS LOS ALUMNOS EN LA TABLA          */
        SelectAll() {

            if (this.parametros.evento == 'edit') {
                return
            } else {
                if (this.allSelected) {
                    this.AlumnosSeccion.forEach(function (item) {
                        item.alumno_check = true
                    })
                    this.validateForm({ index: 3, value: true });
                } else {

                    if (!this.disabledEdit) {
                        this.AlumnosSeccion.forEach(function (item) {
                            item.alumno_check = false
                        })
                        this.validateForm({ index: 3, value: false });
                    }
                }
            }

        },
        /** 
         _____________________________________________________________
        |          MÉTODO ABRIR MODAL PARA AÑADIR LA CLASE          */
        async AddItem() {

            try {
                let params = { id: this.datosSeccion.id_seccion }
                let seccion = await axios.post("/sistema/integral/getSeccionAdm/", { filter: params })
                this.datosSeccion.nombre_seccion = seccion.data[0].nombre_seccion
            } catch (error) {
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })
            }

            //this.estadoConsulta = false //actualizar modal de seleccionar clases
            // this.LimpiarForm()                

        },
        /** 
         _____________________________________________________________
        |          MÉTODO ABRIR MODAL PARA EDITAR LA CLASE          */
        EditItem() {

            this.GetAlumnoEvalSelected();
        },
        /** 
         ____________________________________________________________________________________
        |          MÉTODO GUARDAR INFORMACION - EJECUTAR SP DE VARIAS ENTIDADADES          */
        async SaveItem() {

            let atLeastOne = this.AlumnosSeccion.some((item) => item.alumno_check);
            this.validateForm({ index: 3, value: atLeastOne });
            this.setEvalAlumnos({
                id_usuario: parseInt(this.datoLogin.id, 10),
                id_colegio: this.parametros.items.id_colegio,
                tipo_calificacion: this.parametros.items.tipo_calificacion,
                id_forma_evaluacion: this.parametros.items.id_forma_evaluacion,
                id_estado_evaluacion: this.parametros.items.id_forma_evaluacion == 2 ? 3 : 1,
                id_us_ing: parseInt(this.datoLogin.id, 10),
                fec_us_ing: new Date(Date.now()).toISOString(),
                alumnosTodos: this.AlumnosSeccion
            });
            this.savenotif();
            this.$emit('validate', true);
            this.$nextTick(async () => {

                // SE VALIDA EXTRA QUE EXISTAN COMPETENCIAS PARA VLAIDAR EL ESTADO TRUE
                if (this.parametros.evento == 'edit') {
                    if (this.evaluacionCompetencias && this.evaluacionCompetencias.length != 0) {
                        this.validateForm({ index: 2, value: true });
                    }
                }

                if (this.$refs.formEvaluacionAlumno.validate() && this.formValidados) {

                    /*________LÓGICA PREGUNTAS_______*/
                    let dataPreguntas = this.listaPreguntasArray.map(item => ({
                        ...item,
                        id_banco_pregunta: item.id,
                        id_us_ing: this.datoLogin.id,
                        id_us_mod: null,
                        fec_us_ing: new Date(Date.now()).toISOString(),
                        fec_us_mod: null
                    }));

                    const totalData = {
                        informacion: this.evaluacionInformacion,
                        preguntas: dataPreguntas,
                        competencias: this.evaluacionCompetencias,
                        alumnos: this.evaluacionAlumnos,
                    }
        
                    try {

                        await axios.post("/evaluacion/programacion/SP_addupdate", totalData)
                        this.$emit('close');
                        this.setEnviarMens({ tipo: 'S', mensaje: `Evaluacion ${this.textAlert}`, tiempo: null });

                    } catch (error) {
                        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })
                    }

                } else {
                    this.setEnviarMens({ tipo: "W", mensaje: `Validar los campos de los pasos anteriores`, tiempo: null })
                }
            });

        },

        async savenotif() {
            let titulo = '';
            let contenido = '';
            let tema = '';
            let action = '';
            let type_action = '';

            const filteredUsers = this.AlumnosSeccion.filter(user => user.alumno_check);

            if (this.parametros.evento == 'add') {
                titulo = 'Evaluación creada';
                contenido = 'Se programo una evaluación';
                type_action = 'agregar';
                action = 'fas fa-tasks'
                tema = this.parametros.temas.map(tema => tema.nombre_clase).join(' | ');
            } else {
                titulo = 'Evaluación editada';
                action = 'fas fa-edit'
                contenido = 'Se edito la evaluación ' + this.parametros.items.nombre_evaluacion;
            }


            const fechaActual = new Date();
            const horaActual = fechaActual.toLocaleTimeString('en-GB', {
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                hour12: false
            });

            // Iterar sobre cada tema en el array
            const datanotif = {
                id_colegio: this.datoLogin.id_colegio,
                id_ano_lectivo: this.datoLogin.id_ano_lectivo,
                titulo_notif: titulo,
                contenido_notif: contenido,
                id_perfil: this.datoLogin.id_perfil,
                id_usuario: this.datoLogin.id,
                fecha_notif: fechaActual,
                fecha_venc: this.parametros.items.fecha_informat,
                hora_notif: horaActual,
                id_seccion: this.parametros.items.id_seccion,
                id_curso: this.parametros.items.id_curso,
                tema_clase: tema,
                icon_notif: action,
                event_action: type_action,
                type_notif: 'evaluacion',
                alumnos: filteredUsers,
            };

            try {
                const response1 = await axios.post("/notification/persona/addusernotif/", datanotif);
                this.setEnviarMens({ tipo: `${response1.data.messageT}`, mensaje: `${response1.data.message}`, tiempo: null });
            } catch (error) {
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
            }

        },
        /** 
         _______________________________________________
        |          MÉTODO LIMPIAR FORMULARIO          */
        LimpiarForm() {
            this.allSelected = false;
            this.datosSeccion = {}
            this.$refs.formEvaluacionAlumno.resetValidation()
        },
    }
};
</script>